import { type FC } from "react";
import IconButton from "../../atoms/buttons/IconButton";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";
import Tooltip from "../Tooltip";
import Body from "../../atoms/typography/Body";
import { FixIcon } from "../../atoms/icons/FixIcon";

interface Props {
  onClick: () => void;
}

const HandleMonitorEventButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Tooltip
        content={
          <Body color={theme.colors.white}>
            {t("aml.handleMonitoringEvent")}
          </Body>
        }
      >
        <IconButton
          icon={<FixIcon color={theme.colors.warning} />}
          color={theme.colors.warning20}
          onClick={onClick}
        />
      </Tooltip>
    </div>
  );
};

export default HandleMonitorEventButton;
